import React from 'react';
import '../App.css';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useConfig } from '../context/ConfigContext';
import { useAuth } from '../context/AuthContext.jsx';
import { useEffect, useState, useCallback } from "react";
import { useSearchParams } from "react-router-dom";
import TabSelector from '../components/profileTabs.js';
import axios from 'axios';
import FavoriteButton from "../components/favoriteButton";
import LikeButton from "../components/likeButton";
import ReactButton from "../components/reactButton";
import MorphModal from '../components/morphModal.js';
import SketchModal from '../components/sketchModal.js';


export const Profile = () => {
	const { token, id } = useAuth();
	const { backendApiBaseUrl, isTesting } = useConfig();
	const [items, setItems] = useState([]);
	const [selectedItem, setSelectedItem] = useState(null);
	const [hasMore, setHasMore] = useState(true);
	const [searchParams, setSearchParams] = useSearchParams();
	const [sortOrder, setSortOrder] = useState(searchParams.get("sort") || "Newest");
	const [cursor, setCursor] = useState(null);
	const [tab, setTab] = useState('Uploads');
	const [adminMode, setAdminMode] = useState(false);

	const handleOpenModal = (item) => {
        setSelectedItem(item);
    };

    const handleCloseModal = () => {
        setSelectedItem(null);
    };

	const fetchData = useCallback(async (cursorId = null, filters = {}) => {
		if (!token?.token) return;
		try {
			const url = new URL(`${backendApiBaseUrl}/profile/${tab.toLowerCase()}`)
			if (cursorId) {
				url.searchParams.append("cursor", cursorId)
			}

			const cleanFilters = Object.fromEntries(
				Object.entries(filters).filter(([key, value]) => value !== undefined && value !== null && value !== "")
			);
			
			const response = await axios.post(url.toString(), {
				filters: cleanFilters,
				userId: id,
                cursor: cursorId
			},
			{
				headers: {
					"Authorization": `Bearer ${token.token}`,
				}
			});

			const { items: rawItems, hasMore: moreAvailable, cursor: newCursor } = response.data;

			setCursor(newCursor);
			setHasMore(moreAvailable);

			const extractContent = (item) =>
				item.morph || item.idol || item.album || item.sketch || item.frame;

			const normalizeItem = (item, tab) => {
				const content = extractContent(item);
				if (!content) return null;

				const rawUsername = content?.username ?? content?.user?.username;
				const username = rawUsername?.replaceAll('"', '') ?? "Unknown";
				let images = content.images || [];
				
				return {
					id: content.id,
					type: item.targetType || item.itemType,
					actorUsername: username,
					card_code: content.cardCode,
					description: content.description,
					character: content.character,
					images,
					series: content.series,
					sketcher: content.sketcher,
					inkwell: content.inkwell,
					likeReactCount: content._count?.reactions || content._count?.likes || 0,
					favoriteCount: content._count?.favorites || 0,
					uniqueReactionsCount: content.uniqueReactionsCount || 0,
					fireReactionsCount: content.fireReactionsCount || 0,
					prettyReactionsCount: content.prettyReactionsCount || 0,
					userReaction: (Array.isArray(content.reactions) && content.reactions.length > 0) ? content.reactions[0].type : null,
					hasLiked: Array.isArray(content.reactions || content.likes) && (content.reactions || content.likes).length > 0,
					hasFavorited: Array.isArray(content.favorites) && content.favorites.length > 0,
				};
			};

			const transformed = rawItems
				.map(item => {
					if (tab === 'Frames') {
						const frame = item.frame;
						if (!frame) return null;
						return {
							id: frame.id,
							type: 'FRAME',
							title: frame.name || "Unnamed Frame",
							images: [],
							likeCount: frame._count?.likes || 0,
							favoriteCount: frame._count?.favorites || 0,
						};
					}

					return normalizeItem(item, tab);
				})
				.filter(Boolean);

				if (cursorId) {
					setItems((prev) => [...prev, ...transformed]);
				} else {
					setItems(transformed);
				}
		} catch (err) {
			if (isTesting) {
				console.error("Failed to fetch tab content", err);
			}
		}
	}, [tab, backendApiBaseUrl, id, token.token, isTesting]);

	useEffect(() => {
		fetchData(null, { sort: sortOrder });
		
		
	}, [fetchData, sortOrder]);

	const fetchMoreData = () => {
		if (!hasMore) {
			return;
		}

		if (cursor) {
			fetchData(cursor, { sort: sortOrder });
		}
	};

	const handleSort = (value) => {
		setSortOrder(value);

		setSearchParams(prev => {
			const params = new URLSearchParams(prev);
			params.set("sort", value);
			return params;
		});
	};

	const handleAdminModeToggle = () => {
        setAdminMode(!adminMode)
    };

	const handleDeleteItem = async (itemId, type) => {
		if (!token?.token) return;
        const confirm = window.confirm("Are you sure you want to delete this morph?");
        if (!confirm || !type || !itemId) return;
        try {
			let deleteUrl;
			if (type === 'MORPH') {
				deleteUrl = new URL(`${backendApiBaseUrl}/profile/morphs/delete`);
			} else if (type === 'SKETCH') {
				deleteUrl = new URL(`${backendApiBaseUrl}/profile/sketches/delete`);
			}

			await axios.delete(deleteUrl.toString(), {
				headers: {
					"Authorization": `Bearer ${token.token}`,
				},
				data: {
					id: itemId,
					userId: id
				}
			});

			fetchData();
        } catch (err) {
			if (isTesting) {
             console.error('Error deleting item', err);
			}
        }
    };

	return (
		<div className='container-fluid vh-100 vw-100 m-0 p-0'>
			<div className="container-fluid">
				<div className="row ">
				</div>

				<div className='row'>
					<div className='col-12 col-md-5' id="infiniteScrollContainer" style={{flexGrow: 1, padding: 0}}>
						<div className="d-flex justify-content-between align-items-center px-4 rounded">
							<div className='p-2'>
								{tab === 'Uploads' ? (
									<button
										type="button"
										className="btn btn-outline-danger btn-sm"
										onClick={() => handleAdminModeToggle()}
									>
										Delete Mode
									</button>
								) : null}
							</div>
							<div>
								<TabSelector currentTab={tab} setTab={setTab} />
							</div>
							<div className='d-flex justify-content-end align-items-center'>
								<div className="p-2 ">
									<select className="form-select" value={sortOrder} style={{color:"black"}} onChange={(e) => handleSort(e.target.value)}>
										<option className='profile-filter-dropdown' value="Newest">Newest</option>
										<option className='profile-filter-dropdown' value="Oldest">Oldest</option>
									</select>
								</div>
							</div>
						</div>
						
						{items.length === 0 ? (
                            <div className="text-center mt-4" style={{  color:"#FFF" }}>
                                No items found
                            </div>
                        ) : (
							<InfiniteScroll
								dataLength={items.length}
								next={fetchMoreData}
								hasMore={hasMore}
								loader={<h4>Loading...</h4>}
								scrollableTarget="infiniteScrollContainer"
								className="itemScrollableArea"
							>
								{items.map(item =>
									<div key={`${item.type}-${item.id}`} className="scroll-item">
										<div className="image-container">
											{item.images.length > 0 && (
												<img
													src={item.images[0].presignedUrl}
													alt="Item Preview"
													style={{ maxWidth: '100%', paddingBottom: '10px' }}
													onClick={() => handleOpenModal(item)}
												/>
											)}
											<div className="card-body">
												<h5 className="card-title">{item.title}</h5>
												<p>{item.type}</p>

												<div style={{ display: 'flex', justifyContent: 'space-between' }}>
													{item?.type === 'MORPH' && (
														<>
															<LikeButton
																itemType={item.type}
																itemId={item.id}
																userId={id}
																hasLikedInitial={item.hasLiked}
																likeCountInitial={item.likeReactCount}
															/>
															<FavoriteButton
																itemType={item.type}
																itemId={item.id}
																userId={id}
																hasFavoritedInitial={item.hasFavorited}
																favoriteCountInitial={item.favoriteCount}
															/>
														</>
													)}
													{item?.type !== 'MORPH' && (
														<>
															<ReactButton
																itemType={item.type}
																itemId={item.id}
																userId={id}
																hasReactedInitial={item.userReaction}
																reactCountInitial={item.likeReactCount}
																uniqueReactionsCount={item.uniqueReactionsCount}
																fireReactionsCount={item.fireReactionsCount}
																prettyReactionsCount={item.prettyReactionsCount}
															/>

															<FavoriteButton
																itemType={item.type}
																itemId={item.id}
																userId={id}
																hasFavoritedInitial={item.hasFavorited}
																favoriteCountInitial={item.favoriteCount}
															/>
														</>
													)}
												</div>

												{(adminMode && (tab === 'Uploads')) ? (
													<button type="button" className="btn btn-outline-danger btn-sm" onClick={() => handleDeleteItem(item.id, item.type)}>
														Delete
													</button>
												): null}
											</div>
										</div>
									</div>
								)}
							</InfiniteScroll>
						)}
						{selectedItem?.type === 'MORPH' && (
                            <MorphModal
                                selectedItem={selectedItem}
                                show={selectedItem !== null}
                                onClose={handleCloseModal}
                            />
                        )}
						{selectedItem?.type === 'SKETCH' && (
                            <SketchModal
                                selectedItem={selectedItem}
                                show={selectedItem !== null}
                                onClose={handleCloseModal}
                            />
                        )}
					</div>
				</div>
			</div>
		</div>
	);
};
